import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetNewsAndEventsListSlice = createSlice({
    name: "getNewsAndEvents",
    initialState,
    reducers: {
        getNewsAndEventsRequest(state) {
            state.loading = true;
        },
        getNewsAndEventsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getNewsAndEventsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getNewsAndEventsRequest,
    getNewsAndEventsRequestSuccess,
    getNewsAndEventsRequestError,
} = GetNewsAndEventsListSlice.actions;

export default GetNewsAndEventsListSlice.reducer;
